import { useDispatch } from 'react-redux';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import { useEffect, useMemo, useState } from 'react';
import dayjs from 'dayjs';
import CourseIncomeFIlter from './components/CourseIncomeFIlter';
import { day31Columns, monthColumns } from './utils/courseIncomeMonthDayColumn';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import Stack from '@mui/material/Stack';
import { useSelector } from 'react-redux';
import { getCourseIncomeTable } from '../../../../redux/features/crdMigrationSlice';

export default function CourseIncome() {
  // normal variable
  const dispatch = useDispatch();

  /***********************************************/

  // react state
  const [year, setYear] = useState(dayjs().year());
  const [month, setMonth] = useState({ id: dayjs().month() + 1, value: '' });
  const [basedOn, setBasedOn] = useState({ id: 1, value: '' });
  const [userType, setUserType] = useState(null);
  const [type, setType] = useState({ id: 1, value: '' });
  const [creditedAcc, setCreditedAcc] = useState(null);
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
  });
  /***********************************************/

  // redux state

  const courseIncomeTable = useSelector((state) => state.crdMigration.courseIncomeTable.data);
  const loading = useSelector((state) => state.crdMigration.courseIncomeTable.loading);

  /***********************************************/

  const dispatchParams = useMemo(() => {
    const params = {
      page: tableState?.page,
      limit: tableState?.pageSize,
      year,
      based_on: basedOn?.id,
      type: type?.id,
    };

    if (tableState?.search) {
      params.search = tableState.search;
    }

    // Month only for Daywise
    if (type?.id === 2 && month?.id) {
      params.month = month.id;
    }

    /* --------------------------
     USER TYPE FIX
  -------------------------- */

    if (userType) {
      if (userType.id === -1) {
        params.user_type = null; // All
      } else {
        params.user_type = userType.id; // 1,2,3
      }
    }

    /* --------------------------
     CREDIT ACCOUNT FIX
  -------------------------- */

    if (creditedAcc) {
      // If All (-1) -> null
      if (creditedAcc.id === -1) {
        params.credit_acc = null;
      }

      // If Indian (2) -> send 1
      else if (creditedAcc.id === 2) {
        params.credit_acc = 1;
      }

      // If GCC (3) -> send 2
      else if (creditedAcc.id === 3) {
        params.credit_acc = 2;
      }

      // If N/A (1) -> skip completely
    }

    return params;
  }, [tableState, year, month, basedOn, userType, type, creditedAcc]);

  /***********************************************/

  // mounting Fetch
  useEffect(() => {
    dispatch(getCourseIncomeTable(dispatchParams));
  }, [dispatch, dispatchParams]);

  /***********************************************/

  // const rows = useMemo(() => {
  //   if (!courseIncomeTable) return [];

  //   return courseIncomeTable.map((item) => ({
  //     id: item.sl_no,
  //     slNo: item.sl_no,
  //     courseName: item.course_name,
  //     jan: item.jan_income,
  //     feb: item.feb_income,
  //     mar: item.mar_income,
  //     apr: item.apr_income,
  //     may: item.may_income,
  //     jun: item.jun_income,
  //     jul: item.jul_income,
  //     aug: item.aug_income,
  //     sep: item.sep_income,
  //     oct: item.oct_income,
  //     nov: item.nov_income,
  //     dec: item.dec_income,
  //     total: item.total_income,
  //   }));
  // }, [courseIncomeTable]);
  const rows = useMemo(() => {
    if (!courseIncomeTable) return [];

    return courseIncomeTable.map((item) => {
      const baseRow = {
        id: item.sl_no,
        slNo: item.sl_no,
        courseName: item.course_name,
        total: item.total_income,
      };

      // Month wise
      if (type?.id === 1) {
        return {
          ...baseRow,
          jan: item.jan_income,
          feb: item.feb_income,
          mar: item.mar_income,
          apr: item.apr_income,
          may: item.may_income,
          jun: item.jun_income,
          jul: item.jul_income,
          aug: item.aug_income,
          sep: item.sep_income,
          oct: item.oct_income,
          nov: item.nov_income,
          dec: item.dec_income,
        };
      }

      // Day wise
      if (type?.id === 2) {
        const dayData = {};

        for (let i = 1; i <= 31; i++) {
          dayData[`d${i}`] = item[`day_${i}_income`];
        }

        return {
          ...baseRow,
          ...dayData,
        };
      }

      return baseRow;
    });
  }, [courseIncomeTable, type]);

  const tableHead = useMemo(() => {
    const conditionedTableHeader =
      type?.id === 1
        ? monthColumns
        : day31Columns.slice(
            0,
            dayjs()
              .year(year ?? null)
              .month((month?.id ?? 1) - 1)
              .daysInMonth(),
          );

    return [
      {
        field: 'slNo',
        headerName: 'Sl No.',
        width: 110,
      },
      {
        field: 'courseName',
        headerName: 'Course Name',
        width: 180,
        toolTipGetter: true,
      },
      ...conditionedTableHeader,
    ];
  }, [type, year, month]);

  return (
    <GlobalWrapper title={'Course Income'}>
      <Stack gap={1}>
        <CourseIncomeFIlter
          month={month}
          setMonth={setMonth}
          year={year}
          setYear={setYear}
          creditedAcc={creditedAcc}
          setCreditedAcc={setCreditedAcc}
          type={type}
          setType={setType}
          userType={userType}
          setUserType={setUserType}
          basedOn={basedOn}
          setBasedOn={setBasedOn}
        />
        <GlobalTable
          headers={tableHead}
          rows={rows}
          loading={loading}
          tableState={tableState}
          setTableState={setTableState}
        />
      </Stack>
    </GlobalWrapper>
  );
}
